import { IconPaths } from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'
import { GerarFaturaForm } from '../modal/GerarFaturaForm'

/** Ação da listagem: gerar uma fatura nova (instituição e período escolhidos no modal). */
export const UsersListGrouping = () => {
  const { t } = useT()
  const { showModal } = useModal()

  const openModal = () =>
    showModal({
      title: t('modal.gerar_fatura'),
      content: <GerarFaturaForm />,
    })

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openModal}>
      {t('gerar_fatura.label')}
    </Button>
  )
}
